import React from 'react'
import PaymentModal from '../components/Houses/paymentModal'
const PaymentConfirmaationPage = () => {
  return (
    <div><PaymentModal/></div>
  )
}

export default PaymentConfirmaationPage